<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you been diagnosed as having erectile dysfunction (ED) which has been shown to indicate greater cardiovascular disease risk?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hasErectileDysfunction">
      <b-form-radio v-model="survey.medicalConditions.hasErectileDysfunction" name="ed"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.medicalConditions.hasErectileDysfunction" name="ed"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hasErectileDysfunction: { required }
    },

    computed: {
      ...mapState(["survey"]),

      hasErectileDysfunction() { return this.survey.medicalConditions.hasErectileDysfunction; },
    },
  };
</script>